import { Check } from 'lucide-react';
import { SiteHeader } from '../layout';

/**
 * Shown to authenticated users whose email is not yet approved
 * in the waitlist. Minimal, on-brand screen that reassures without
 * over-promising. User can sign out to return to the landing page.
 */
export function WaitlistPending({ onSignOut }: { onSignOut: () => void }) {
  return (
    <div className="min-h-screen bg-stone-50 dark:bg-stone-950">
      <SiteHeader mode="loading" />

      <div className="max-w-md mx-auto px-4 sm:px-6 pt-24 pb-12 text-center">
        {/* Subtle check icon */}
        <div className="mx-auto w-16 h-16 rounded-full bg-emerald-50 dark:bg-emerald-900/20 flex items-center justify-center mb-8">
          <Check className="w-8 h-8 text-emerald-500 dark:text-emerald-400" strokeWidth={1.5} />
        </div>

        {/* Headline — serif per design system */}
        <h1 className="text-3xl sm:text-4xl font-serif text-stone-900 dark:text-stone-100 mb-4">
          You're On The List
        </h1>

        {/* Body — concise, no false urgency */}
        <p className="text-stone-500 dark:text-stone-400 text-lg leading-relaxed mb-2">
          Your spot is confirmed. We're expanding access and will send you an invite when it's your turn.
        </p>

        <p className="text-stone-400 dark:text-stone-500 text-sm">
          We'll email you at the address you signed in with.
        </p>

        {/* Sign out link */}
        <div className="mt-12">
          <button
            onClick={onSignOut}
            className="text-sm text-stone-400 dark:text-stone-500 hover:text-stone-600 dark:hover:text-stone-300 transition-colors"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
